module.exports = __webpack_public_path__ + "img/image_lose.f55e97bd.png";